import Immutable from 'seamless-immutable';
import ReducerContainer from '../../helper/reducer-helper';
import { DinnerType } from '../../helper/const';
import actionTypes from '../../consts/dish-menu-action-type';
import { getUrlParam, filterNoneString } from '../../helper/common-helper';

const initialState = Immutable.from({
  shopInfo: {},
});

export default ReducerContainer.createReducer(initialState, {
  [actionTypes.INIT_SHOP_INFO]: (state, payload) => {
    const isWM = getUrlParam('type') === DinnerType.TAKEOUT;

    const updateShopInfo = {
      dishPageTpl: isWM ? payload.dishPageTpl : payload.tsDishPageTpl,
      enableMemberRegistry: payload.enableMemberRegistry,
      dishBoxChargeInfo: isWM && payload.extraCharge ? payload.extraCharge : null,
      isAcceptTakeaway: payload.isAcceptTakeaway,
      isHDL: payload.isHDL,
      guide: payload.guide,
      operateImgUrl: filterNoneString('url', isWM ? payload.operateImgUrl : payload.tsOperateImgUrl),
      operateUrl: filterNoneString('url', isWM ? payload.operateUrl : payload.tsOperateUrl),
      shopLogo: payload.shopLogo,
      orderPageImage: filterNoneString('url', payload.orderPageImage),
      tsOperateUrl: filterNoneString('url', payload.tsOperateUrl),
      tsOperateImgUrl: filterNoneString('url', payload.tsOperateImgUrl),
      orderPageTitle: filterNoneString('word', isWM ? payload.orderPageTitle : payload.tsOrderPageTitle),
      wmCartImageUrl: filterNoneString('url', payload.wmCartImageUrl),
      tsCartImageUrl: filterNoneString('url', payload.tsCartImageUrl),
      sendTimeList: payload.sendTimeList,
      openTimeList: payload.openTimeList,
      shopInfo: {
        isOldMarketing: payload.isOldMarketing,
        commercialName: payload.commercialName,
        openTimeList: payload.openTimeList,
        diningForm: payload.diningForm, // 0 正餐 1 快餐
        isSingleShop: payload.isSingleShop,
        marketCoupon: payload.takeCouponVO || {},
        formatDishesData: {},
        marketList: {},
        marketListUpdate: [],
        marketMatchDishes: false,
        mobile: payload.mobile,
        address: payload.address,
        multiMarketing: [],
        notice: null,
        couponSuccessInfo: null,
        couponSuccess: false,
        isEnableShop: isWM ? payload.isEnableWm : payload.isEnableTs,
        choosePeopleCountFlag: payload.choosePeopleCountFlag,
        serviceSupply: payload.ringVOS,
        openStatus: payload.openStatus,
        isYaZuo: payload.isYaZuo || false,
        goodsNumEditable: payload.goodsNumEditable || false,
        couponList: payload.takeCouponVOS || [],
        ruleId: payload.ruleId,
        planId: payload.planId,
        flag: payload.flag,
        type: payload.type,
      },
    };

    return state.merge(updateShopInfo);
  },
});




// WEBPACK FOOTER //
// ./src/reducer/common/dish-menu.js